const BulkTrackAudioAnalysis = {
  apply: function ({ file, fileInputElement, barContainerElement }) {
    if (!file || !barContainerElement) {
      return;
    }

    if (!this.isSupportedAudioFile(file)) {
      return;
    }

    this.attachUploadedAudioPreview(barContainerElement, fileInputElement);
    this.populateLengthAndTitle(file, fileInputElement, barContainerElement);
    this.populateTempoAndWaveform(file, fileInputElement, barContainerElement);
  },

  isSupportedAudioFile: function (file) {
    const mimeType = (file.type || '').toLowerCase();
    const name = (file.name || '').toLowerCase();

    if (mimeType === 'audio/mpeg' || mimeType === 'audio/wav' || mimeType === 'audio/x-wav') {
      return true;
    }

    return /\.(mp3|wav|aiff|aif)$/.test(name);
  },

  resolveFieldsContainer: function (fileInputElement, barContainerElement) {
    return (fileInputElement && fileInputElement.closest('.fields')) ||
      (barContainerElement && barContainerElement.closest('.fields')) ||
      (fileInputElement && fileInputElement.closest('form')) ||
      (barContainerElement && barContainerElement.closest('form'));
  },

  findInput: function (container, names) {
    if (!container || !names || !names.length) {
      return null;
    }

    const selector = names.map(function (name) {
      return 'input[name="' + name + '"]';
    }).join(', ');

    return container.querySelector(selector);
  },

  attachUploadedAudioPreview: function (barContainerElement, fileInputElement) {
    setTimeout(function () {
      const fieldsContainer = BulkTrackAudioAnalysis.resolveFieldsContainer(fileInputElement, barContainerElement);
      const hiddenInput = fieldsContainer && (
        fieldsContainer.querySelector('input[type=hidden][name$=\"[s3_file_upload_url]\"]') ||
        fieldsContainer.querySelector('input[type=hidden][name=\"track[s3_file_upload_url]\"]')
      );
      const uploadedUrl = hiddenInput && hiddenInput.value;

      if (!uploadedUrl) {
        return;
      }

      const existingAudio = fieldsContainer.querySelector('audio');
      if (!existingAudio) {
        const audioElement = document.createElement('audio');
        audioElement.setAttribute('controls', '');
        const sourceElement = document.createElement('source');
        sourceElement.setAttribute('src', uploadedUrl);
        audioElement.appendChild(sourceElement);
        barContainerElement.parentNode.appendChild(audioElement);
      }

      if (barContainerElement.previousElementSibling) {
        barContainerElement.previousElementSibling.style.display = 'none'; // file input/label
      }
      if (barContainerElement.nextElementSibling && barContainerElement.nextElementSibling.tagName === 'svg') {
        barContainerElement.nextElementSibling.style.display = 'none';
      }
    }, 2000);
  },

  populateLengthAndTitle: function (file, fileInputElement, barContainerElement) {
    const fieldsContainer = BulkTrackAudioAnalysis.resolveFieldsContainer(fileInputElement, barContainerElement);
    const titleInput = BulkTrackAudioAnalysis.findInput(fieldsContainer, ['track[title]']) || (fieldsContainer ? fieldsContainer.querySelector('input[name$=\"[title]\"]') : undefined);
    if (titleInput && titleInput.value.length === 0) {
      titleInput.value = BulkTrackAudioAnalysis.inferTitleFromFileName(file.name || '');
    }

    const reader = new FileReader();

    reader.onload = function (event) {
      const OfflineContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
      if (!OfflineContext) {
        return;
      }

      const offlineContext = new OfflineContext(2, 30 * 44100, 44100);

      offlineContext.decodeAudioData(event.target.result, function (buffer) {
        const duration = buffer.duration;
        const lengthInput = BulkTrackAudioAnalysis.findInput(fieldsContainer, ['track[length]']) || (fieldsContainer ? fieldsContainer.querySelector('input[name$=\"[length]\"]') : undefined);

        if (lengthInput) {
          lengthInput.value = Math.floor(duration);
        }
      });
    };

    reader.onerror = function (event) {
      console.error('An error occurred reading the file: ', event);
    };

    reader.readAsArrayBuffer(file);
  },

  inferTitleFromFileName: function (fileName) {
    let title = (fileName || '').replace(/\.(mp3|wav|aiff|aif)$/i, '');
    title = title.replace(/[_]+/g, ' ');
    title = title.replace(/\s+/g, ' ').trim();

    // Strip common leading track index prefixes, e.g. "01 ", "01 - ", "1_"
    title = title.replace(/^\d{1,3}\s*[-_.]?\s+/, '');
    title = title.replace(/^\d{1,3}[-_.](?=\S)/, '');

    // Strip trailing BPM markers, e.g. "(120)", "(120 bpm)", "[95BPM]"
    title = title.replace(/\s*[\(\[]\s*\d{2,3}\s*(?:bpm)?\s*[\)\]]\s*$/i, '');
    title = title.replace(/\s+\d{2,3}\s*bpm\s*$/i, '');

    title = this.stripLikelyArtistPrefix(title);
    title = title.replace(/\s+/g, ' ').trim();

    if (!title) {
      return '';
    }

    return title
      .split(' ')
      .map(function (part) {
        if (!part || part.length === 0) {
          return part;
        }
        return part.charAt(0).toUpperCase() + part.slice(1);
      })
      .join(' ');
  },

  stripLikelyArtistPrefix: function (title) {
    if (!title || title.indexOf(' - ') === -1) {
      return title;
    }

    const parts = title.split(/\s-\s/);
    if (parts.length < 2) {
      return title;
    }

    const left = (parts.shift() || '').trim();
    const right = parts.join(' - ').trim();

    const leftWordCount = left.split(/\s+/).filter(Boolean).length;
    const leftHasDigits = /\d/.test(left);
    const rightHasLetters = /[a-zA-Z]/.test(right);

    // Conservative: remove prefix only when it looks like a short artist name.
    if (!leftHasDigits && leftWordCount > 0 && leftWordCount <= 4 && rightHasLetters) {
      return right;
    }

    return title;
  },

  populateTempoAndWaveform: function (file, fileInputElement, barContainerElement) {
    const reader = new FileReader();

    reader.onload = function (event) {
      const OfflineContext = window.OfflineAudioContext || window.webkitOfflineAudioContext;
      if (!OfflineContext) {
        return;
      }

      const offlineContext = new OfflineContext(2, 30 * 44100, 44100);

      offlineContext.decodeAudioData(event.target.result, function (buffer) {
        const source = offlineContext.createBufferSource();
        source.buffer = buffer;

        const lowpass = offlineContext.createBiquadFilter();
        lowpass.type = 'lowpass';
        lowpass.frequency.value = 150;
        lowpass.Q.value = 1;
        source.connect(lowpass);

        const highpass = offlineContext.createBiquadFilter();
        highpass.type = 'highpass';
        highpass.frequency.value = 100;
        highpass.Q.value = 1;
        lowpass.connect(highpass);
        highpass.connect(offlineContext.destination);

        source.start(0);
        offlineContext.startRendering();
      });

      offlineContext.oncomplete = function (e) {
        const buffer = e.renderedBuffer;
        const peaks = BulkTrackAudioAnalysis.getPeaks([buffer.getChannelData(0), buffer.getChannelData(1)]);
        const groups = BulkTrackAudioAnalysis.getIntervals(peaks);
        const fieldsContainer = BulkTrackAudioAnalysis.resolveFieldsContainer(fileInputElement, barContainerElement);
        const svg = fieldsContainer ? fieldsContainer.querySelector('svg') : undefined;
        const tempoInput = BulkTrackAudioAnalysis.findInput(fieldsContainer, ['track[tempo]']) || (fieldsContainer ? fieldsContainer.querySelector('input[name$=\"[tempo]\"]') : undefined);

        if (svg) {
          BulkTrackAudioAnalysis.renderWaveform(svg, peaks, buffer.length);
        }

        const top = groups.sort(function (intA, intB) {
          return intB.count - intA.count;
        }).splice(0, 5);

        if (tempoInput && tempoInput.value.length === 0 && top.length > 0) {
          tempoInput.value = top[0].tempo;
        }
      };
    };

    reader.onerror = function (event) {
      console.error('An error occurred reading the file: ', event);
    };

    reader.readAsArrayBuffer(file);
  },

  renderWaveform: function (svg, peaks, bufferLength) {
    svg.innerHTML = '';
    const svgNS = 'http://www.w3.org/2000/svg';
    let rect;

    peaks.forEach(function (peak) {
      rect = document.createElementNS(svgNS, 'rect');
      rect.setAttributeNS(null, 'x', (100 * peak.position / bufferLength) + '%');
      rect.setAttributeNS(null, 'y', 0);
      rect.setAttributeNS(null, 'width', 1);
      rect.setAttributeNS(null, 'height', '100%');
      svg.appendChild(rect);
    });

    rect = document.createElementNS(svgNS, 'rect');
    rect.setAttributeNS(null, 'id', 'progress');
    rect.setAttributeNS(null, 'y', 0);
    rect.setAttributeNS(null, 'width', 1);
    rect.setAttributeNS(null, 'height', '100%');
    svg.appendChild(rect);
    svg.innerHTML = svg.innerHTML; // force repaint in some browsers
  },

  getPeaks: function (data) {
    const partSize = 22050;
    const parts = data[0].length / partSize;
    const peaks = [];

    for (let i = 0; i < parts; i++) {
      let max = 0;
      for (let j = i * partSize; j < (i + 1) * partSize; j++) {
        const volume = Math.max(Math.abs(data[0][j]), Math.abs(data[1][j]));
        if (!max || (volume > max.volume)) {
          max = { position: j, volume: volume };
        }
      }
      peaks.push(max);
    }

    peaks.sort(function (a, b) { return b.volume - a.volume; });
    const loudestHalf = peaks.splice(0, peaks.length * 0.5);
    loudestHalf.sort(function (a, b) { return a.position - b.position; });
    return loudestHalf;
  },

  getIntervals: function (peaks) {
    const groups = [];

    peaks.forEach(function (peak, index) {
      for (let i = 1; (index + i) < peaks.length && i < 10; i++) {
        const group = {
          tempo: (60 * 44100) / (peaks[index + i].position - peak.position),
          count: 1
        };

        while (group.tempo < 90) { group.tempo *= 2; }
        while (group.tempo > 180) { group.tempo /= 2; }
        group.tempo = Math.round(group.tempo);

        if (!(groups.some(function (interval) {
          return (interval.tempo === group.tempo ? interval.count++ : 0);
        }))) {
          groups.push(group);
        }
      }
    });

    return groups;
  }
};

export default BulkTrackAudioAnalysis;
